import React from "react";
import { array } from "prop-types";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism2.m.css";

const Organism2 = ({ stories }) => {
  if (!(stories && stories.length)) {
    return null;
  }

  return (
    <div styleName="wrapper">
      {stories.map((story, index) => (
        <LeftImageRightNews story={story.story} key={index} showExcerpt={false} />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  stories: array.isRequired,
};

export default Organism2;
